import styled from '@emotion/styled'

import {
  CurrencyField as CurrencyFieldComponent,
  DateField as DateFieldComponent,
  TextField as TextFieldComponent,
} from '@/components/Input'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
`

const BaseField = styled.input`
  margin-top: 1rem;
  height: 3.85rem;
`

export const DateField = BaseField.withComponent(DateFieldComponent)

export const TextField = BaseField.withComponent(TextFieldComponent)

export const CurrencyField = BaseField.withComponent(CurrencyFieldComponent)

export const ToggleSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;

  & label {
    cursor: pointer;
  }
`

export const SalaryFieldWrapper = styled.div`
  margin-top: 2.5rem;
`
